'use client'

import type { SearchBarDirectHitProductActionProps } from '@maestro/commerce-blocks/components/search-bar/search.types'

import { useTranslations } from 'next-intl'

import { AddToCartButton } from '@maestro/commerce-blocks/components/add-to-cart-button'
import { ProductQuantityPicker } from '@maestro/commerce-blocks/components/product-quantity-picker'
import { useSearchBarDirectHitProductAction } from '@maestro/commerce-blocks/components/search-bar/batons/use-search-bar-direct-hit-product-action'
import { TriggeredFrom } from '@maestro/data-layer'

export default function SearchBarDirectHitProductAction(
  props: SearchBarDirectHitProductActionProps
) {
  const { product, eventListProps, isStockLoading } = props
  const t = useTranslations('commerce-blocks')
  const {
    isActionVisible,
    variantId,
    cartEntry,
    maxQuantity,
    handleQuantityChange,
  } = useSearchBarDirectHitProductAction({ product })

  if (!isActionVisible) {
    return null
  }

  if (cartEntry) {
    return (
      <ProductQuantityPicker
        id={cartEntry.id}
        quantity={cartEntry.quantity}
        maxQuantity={maxQuantity}
        minQuantity={0}
        controlSize="small"
        onQuantityChange={handleQuantityChange}
      />
    )
  }

  return (
    <AddToCartButton
      product={product}
      variantId={variantId}
      title={t('_globals.add')}
      type="primary"
      notificationType="minimal"
      isDisabled={isStockLoading}
      eventProps={{ eventListProps, triggeredFrom: TriggeredFrom.SEARCH }}
    />
  )
}
